import React from "react";
import ChrEllipsisDropdown from "../Dropdown/ChrEllipsisDropdown";
import { isPresent } from "../../../../../utils/CoreExtensions/ArrayExtensions";

/*
props = {
  actions = {
    pinned: [<component>,...],
    notPinned: [<component>,...]
  }
}
*/

const ChrWidgetActions = (props) => {
  const actions = props.actions;

  const pinnedActionComponents = isPresent(actions.pinned) && actions.pinned.map((action, index) => (
    <div key={index}>
      { action }
    </div>
  ));

  return (
    <div className='d-flex flex-gap-15'>
      <div className="d-flex align-self-center flex-gap-5 flex-wrap">{ pinnedActionComponents }</div>
      { isPresent(actions.notPinned) && <div className="d-flex align-self-center"><ChrEllipsisDropdown elements={ actions.notPinned }/></div> }
    </div>
  )
}

export default ChrWidgetActions;
